import React, { useEffect, useState } from 'react';
import { formatPoints } from '../../../utils/helper';
import { Link } from 'react-router-dom';
import { getRewardData } from '../../auth/auth';
import Loader from '../../partial/Loader';
import { getFirstSentence } from '../../../utils';

const RewardsContent = ({ updateFormData, setActiveSection }) => {
	const [loader, setLoader] = useState(true);
	const [selectedReward, setSelectedReward] = useState(null);
	const [response, setResponse] = useState([]);
	const [showPopup, setShowPopup] = useState(false);
	const [popupReward, setPopupReward] = useState(null);
	const token = JSON.parse(localStorage.getItem('token_gen'));
	const customerid = localStorage.getItem("customerid");
	useEffect(() => {
		setLoader(true);
		const quarterlypoints = localStorage.getItem('quarterlypoints');
		const quarterlypoint = quarterlypoints > 20000 ? 20000 : quarterlypoints
		getRewardData(token.access_token, 'MER000325', quarterlypoint)
			.then((res) => {
				   const uniqueRewards = (res?.data || []).filter(
          (item, index, self) =>


            index === self.findIndex(r => r.id === item.id)
        );
				setResponse(uniqueRewards || []);
				setLoader(false);
			})
			.catch(() => {
				setLoader(false);
			});
	}, []);

	const rewardsData = response.reduce((acc, item) => {
		const category = item.category.toLowerCase();
		const existingCategory = acc.find(
			(cat) => cat.category.toLowerCase() === category,
		);

		const rewardItem = {
			id: item.id,
			title: item.reward,
			points: parseInt(item.amount_required * 100),
			content: item.reward_display,
			img: item.imageUrl,
		};

		if (existingCategory) {
			existingCategory.list.push(rewardItem);
		} else {
			acc.push({
				category: category.charAt(0).toUpperCase() + category.slice(1),
				list: [rewardItem],
			});
		}

		return acc;
	}, []);

	const handleSelect = (reward) => {
		const formattedData = {
			Name: reward.title,
			totalpoint: reward.points,
		};

		setSelectedReward(reward);
		updateFormData(formattedData);
		setActiveSection('achievement_timeline');
	};

	const handlePopup = (reward) => {
		setPopupReward(reward);
		setShowPopup(true);
	};

	const formatRewardContent = (content) => {
		return content.split('\n').map((line, index) => (
			<React.Fragment key={index}>
				{line}
				{index < content.split('\n').length - 1 && <br />}
			</React.Fragment>
		));
	};
	return (
		<div
			className='timeline-content-inner active'
			id='select_reward'>
			{loader && <Loader />}
			{!loader && rewardsData.length === 0 && (
				<div>No rewards available</div>
			)}
		
				<div
				
					className='timeline-rewards mb-2'>
					{/* <h4>{category.category}</h4> */}
					<h4>Rewards</h4>
						{rewardsData.map((category, index) => (
							<div
				
					className='timeline-rewards mb-2'>
					<div className='timeline-rewards-grid'>

						{category.list.map((reward) => {
							const firstLine = getFirstSentence(reward?.content);
							return (
								<div
									key={reward.id}
									className={`timeline-rewards-box ${selectedReward?.id === reward.id
										? 'border-2 border-blue-500'
										: ''
										}`}>
									<div className='timeline-rewards-box-image' style={{ cursor: "pointer" }} onClick={() =>
										handlePopup(reward)
									}>
										{customerid !== "13217511" && (
											<div className="overlay_lock">
												<span className="lock_icon">
													<i class="fa-solid fa-lock"></i>
													{/* <p className="message1">{customerDetail?.InvoicedLockedReason}</p> */}
												</span>
											</div>)}
										<img
											src={reward.img}
											alt={reward.title}
										// onClick={() => handleSelect(reward)}
										/>
									</div>
									{showPopup &&
										popupReward?.id === reward.id && (
											<div className='popup show'>
												<div className='popup-box reward-box'>
													<Link
														to=''
														className='close-popup'
														onClick={() =>
															setShowPopup(false)
														}>
														X
													</Link>
													<div className='popup-box-inner'>
														{/* Render formatted content */}
														<p>
															{formatRewardContent(
																popupReward.content,
															)}
														</p>
														<p className='points'>
															{formatPoints(
																popupReward.points,
															)}{' '}
															Points Required
														</p>
														{customerid === "13217511" && (
															<button
																className='btn btn-primary btn-full'
																onClick={(e) => {
																	e.stopPropagation();
																	handleSelect(
																		reward,
																	);
																}}>
																Select Reward
															</button>)}
													</div>
												</div>
											</div>
										)}
									<div className='timeline-rewards-box-content'>
										<h5 style={{ cursor: "pointer" }} onClick={() =>
											handlePopup(reward)
										}>{reward.title}</h5>
										<span className='points'>
											{formatPoints(reward.points)} Points (₹{formatPoints(reward.points / 100)})
										</span>

										{firstLine ? (
											<span
												style={{
													display: 'block',
													marginTop: '0.125rem',
													marginBottom: '0.5rem',
													padding: 0,
													fontSize: '0.875rem',
													color: '#4b5563',
													lineHeight: '1.4',
													fontWeight: 400,
													whiteSpace: 'normal',
													overflow: 'visible',
													textOverflow: 'clip',
												}}>
												{firstLine}
											</span>
										) : (
											<></>
										)}

										<div className='timeline-rewards-box-content-inner'>
											<div className='timeline-rewards-box-content-inner-left'>
												<button
													onClick={() =>
														handlePopup(reward)
													}
													className='text-blue-500'>
													View details
												</button>
											</div>
											{customerid === "13217511" && (
												<div className='timeline-rewards-box-content-inner-right'>
													<button
														className={`btn ${selectedReward?.id ===
															reward.id
															? 'bg-blue-500 text-white'
															: ''
															}`}
														onClick={(e) => {
															e.stopPropagation();
															handleSelect(reward);
														}}>
														<span>
															{selectedReward?.id ===
																reward.id
																? 'Selected'
																: 'Select'}
														</span>
													</button>
												</div>)}
										</div>
									</div>
								</div>
							);
						})}
					</div>
					</div>
					))}
				</div>
			
		</div>
	);
};

export default RewardsContent;
